_   = require('underscore')
Vue = require('vue/dist/vue')

module.exports =
  namespaced: true

  state:
    height:     0
    width:      0
    scrollTop:  0
    scrollLeft: 0
    footerSpacerHeight: 0

  mutations:

    _updateClientWidthHeight: (state, payload) ->
      Vue.set(state, 'height', payload.height)
      Vue.set(state, 'width', payload.width)

    _updateScroll: (state, payload) ->
      Vue.set(state, 'scrollTop', payload.scrollTop)
      Vue.set(state, 'scrollLeft', payload.scrollLeft)

    _setFooterSpacerHeight: (state, height) ->
      height = 0 unless _.isNumber(height) && !_.isNaN(height)
      height = 0 unless height >= 0
      Vue.set(state, 'footerSpacerHeight', height)

  actions:

    updateClientWidthHeight: (context, payload) ->
      context.commit('_updateClientWidthHeight', payload)

    updateScroll: (context, payload) ->
      context.commit('_updateScroll', payload)

    updateFooterSpacerHeight: (context, payload) ->
      context.commit('_setFooterSpacerHeight', payload.height || 0)



// WEBPACK FOOTER //
// ./assets/js/shared/store/window/index.coffee